import React from 'react'
import { Overlay } from './Styles'

interface Props {
  show: boolean
  handleClose: () => void
}

const Modal: React.FC<Props> = ({show, children, handleClose}) => {
  if (!show) return null
  return <Overlay onClick={handleClose}>{children}</Overlay>
}

export default Modal
